const accordionsBlocks = document.querySelectorAll( '.block-name-promo-accordions' );

if ( accordionsBlocks ) {

  accordionsBlocks.forEach( function( accordionsBlock ) {

    accordionsBlock.querySelectorAll( 'summary' ).forEach( function( summary ) {

      summary.addEventListener( 'click', function( event ) {

        const clickedDetails = event.currentTarget.parentNode;

        if ( clickedDetails.getAttribute( 'open' ) === null ) {

          clickedDetails.parentNode.querySelectorAll( 'details' ).forEach( function( details ) {

            if ( event.currentTarget !== details ) {

              details.removeAttribute( 'open' );

            } else {

              details.setAttribute( 'open', 'open' );
            }

          } );

        }

      } );

    } );

  } );
}
